import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MESSAGE_SETTINGS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetMessageSettingsRequestPayload,
  GetMessageSettingsResult,
  MessageSettings,
} from '../types/getMessageSettings.types';

export const getMessageSettings = (builder: BuilderType) =>
  builder.query<MessageSettings[], GetMessageSettingsRequestPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_MESSAGE_SETTINGS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMessageSettingsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.MessageSettings;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
